var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthEngineBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 161,
    viewBox: "0 0 181 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181 154C181 157.866 177.883 161 174.038 161H6.96154C3.11679 161 0 157.866 0 154C0 150.134 3.11679 147 6.96154 147H13.9231V91C13.9231 87.134 17.0399 84 20.8846 84H41.7692C45.614 84 48.7308 87.134 48.7308 91V147H62.6538V49C62.6538 45.134 65.7706 42 69.6154 42H97.4615C101.306 42 104.423 45.134 104.423 49V147H118.346V7C118.346 3.13401 121.463 0 125.308 0H160.115C163.96 0 167.077 3.13401 167.077 7V147H174.038C177.883 147 181 150.134 181 154Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthEngineBlue);
export default __webpack_public_path__ + "static/media/growth-engine-blue.90fdde2d5e4b9c7f5a21d600b0e6ab4a.svg";
export { ForwardRef as ReactComponent };